import axios from 'axios'
import {
  RangeParamDocument,
  RangeParameter,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  UpdateRangeParameterDto,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getRangeParamsTable(dto: any) {
  return axios.post<ResponseObjectPaginated<RangeParamDocument[]>>(
    `${BASEURL}/BillingRange/getListRangeCab`,
    dto,
  )
}
export function getRangeParamsById(id: any) {
  return axios.get<ResponseObject<RangeParameter>>(
    `${BASEURL}/BillingRange/getInformationRangeById?Id=${id}`,
  )
}

export function createRangeParams(dto: UpdateRangeParameterDto) {
  return axios.post<ResponseCRUD>(`${BASEURL}/BillingRange/CreateRangeCab`, dto)
}

export function updateRangeParams(dto: UpdateRangeParameterDto) {
  return axios.post<ResponseCRUD>(`${BASEURL}/BillingRange/updateRangeCab`, dto)
}
